import { Center, Spinner } from 'src/components/atoms';
import { LoadingStyled } from './Loading.styles';
export const Loading = () => (
  <LoadingStyled>
    <Center>
      <Spinner variant="secondary" size="xlarge" />
    </Center>
  </LoadingStyled>
);
